const maxConfigurableRequestProductCount = 120

export const REQUIRED_MESSAGE = "Required"
export const INVALID_MESSAGE = "Invalid"
export const RE_EXPORT = "REEXPORT_PHYTOSANITARY"
export const ENTER_VALID_VALUE_MESSAGE = "Enter a valid value"
export const TIME_IN_PAST_MESSAGE =
  "Please select a date that is not in the past"
export const TIME_IN_FUTURE_MESSAGE =
  "Please select a date that is not in the future"

export const MaxLengthError = (max: number) => `Maximum length is ${max}`

export const MAXIMUM_ERROR = (max: number) => `Exceed maximum value ${max}`

export const PROMPT_MESSAGE_FOR_QUANTITY_REASON =
  "You have reached the maximum number of products you can add to this request"

export const PROMPT_MESSAGE_FOR_REQUIRED_FIELDS =
  "Please enter a request name and format for shipping before adding product"

export const UNSUCCESSFUL_SAVE_MESSAGE = "Save unsuccessful, please try again"

export const FILE_UPLOAD_ERROR = "Could not upload document. Please try again."

export const FILE_INVALID_FILE_TYPE = "Invalid file type"
export const FILE_INVALID_FILE_SIZE = "File size is too large"
export const FILE_INVALID_FILE_NAME = "Invalid file name"

export const REQUIRED_PRODUCT_MESSAGE = "Please add a product"
export const INVALID_PRODUCT = "Invalid product"
export const INVALID_EMAIL = "Invalid email"

export const RECIPIENT_COUNTRY_MUST_BE_NZ =
  "Recipient address must be in New Zealand"

export const PROMPT_MESSAGE_FOR_REQUEST_NAME =
  "Please enter a request name before viewing products"
export const SEE_ALL_PRODUCT_MESSAGE =
  "Click 'See all products' to view and edit all products  in this export request."

export const ERROR_MESSAGE_TITLE = "Sorry, something went wrong"
export const INFO_MESSAGE_FOR_DISBALED_REQUEST_REPLACEMENT =
  "Cannot replace the export request twice"

export const ERROR_MESSAGE_FOR_CANCEL_CHEMESTRY_TEST =
  "Invalid. Only letters, numbers, and some punctuation allowed."

export const CONFIG_REQUEST_NUMBER_CONSIGNOR_ID_REQUIRED_FOR_PRODUCT =
  "Please enter a transfer number and Consignor ID before adding products"

export const CONFIG_REQUEST_NUMBER_CONSIGNOR_ID_REQUIRED_FOR_VIEWING_PRODUCT =
  "Please enter a transfer number and Consignor ID before viewing products"

export const EXPORT_REQUEST_NUMBER_CONSIGNOR_ID_REQUIRED_FOR_PRODUCT =
  "Please enter a certificate number and Consignor id before adding products"

export const EXPORT_REQUEST_NUMBER_CONSIGNOR_ID_REQUIRED_FOR_VIEWING_PRODUCT =
  "Please enter a certificate number and Consignor id before viewing products"

export const PHYTO_REQUEST_NUMBER_CONSIGNOR_ID_REQUIRED_FOR_PRODUCT =
  "Please enter an Organisation and Request Name before adding products"

export const PHYTO_REQUEST_NUMBER_CONSIGNOR_ID_REQUIRED_FOR_VIEWING_PRODUCT =
  "Please enter an Organisation and Request Name before viewing products"

export const PHYTO_REEXPORT_REQUEST_NUMBER_CONSIGNOR_ID_REQUIRED_FOR_PRODUCT =
  "Please enter an Organisation and Request Name before adding product"

export const CONFIG_ADD_PRODUCT_REQUIRED_FOR_VIEWING_PRODUCT =
  "Please add or save product before viewing products"

export const SAVE_DRAFT_REQUIRED_FOR_ADD_EDIT_PRODUCT =
  "Please save a draft before adding or editing products"

export const ERROR_MESSAGE_FOR_COPY_TRANSFER =
  "You must save a draft before you can create a copy"

export const ERROR_MESSAGE_FOR_COPY_EXPORT =
  "You must save a draft before you can create a copy"

export const COPY_TRANSFER_MODAL_MESSAGE =
  "This transfer request and all its data will be copied over to a new request. You will be taken directly to this new unsaved request upon confirmation"

export const COPY_EXPORT_MODAL_MESSAGE =
  "This export request and all its data will be copied over to a new request. You will be taken directly to this new unsaved request upon confirmation"

export const REQUIRES_ATTENTION_WARNING_MESSAGE =
  "The template on which this certificate is based is no longer current. Please re-select your declarations and ensure all necessary information is supplied."

export const EXPORT_CANCEL_MIN_LENGTH_ERROR = "Reason is required"

export const EXPORT_CANCEL_MAX_LENGTH_ERROR =
  "Reason should have less than 4000 characters"

export const CONCURRENT_EDIT_WARNING_MESSAGE =
  "Unable to edit request: This request has been modified since it was last opened. Please refresh the page and try again."

export const CONCURRENT_EDIT_SAVE_OR_SUBMIT_WARNING_MESSAGE =
  "Unable to save or submit request: This request has been modified since it was last opened. Please refresh and try again."

export const UNAUTHORIZED_ACCESS_MESSAGE =
  "[GraphQL] You are not authorised to perform the action"

export const DRAFT_PDF_UNSAVED_ERROR = {
  message: "Please save draft before printing the draft certificate.",
  title: "Please save draft",
}

export const SELECT_VALID_OPTION_MESSAGE =
  "Please select a valid option from the list"

export const REVIEW_FORM_ERRORS_BEFORE_SAVING =
  "Please review the form for any errors before submitting"

export const ERRORS_FOUND_IN_PRODUCTS =
  "Errors found in products. Click here to view all"

export const PRODUCTS_REQUIRED_BEFORE_SUBMIT =
  "Please enter at least one product"

export const DROOLS_ERRORS =
  "Please review the form for any errors before submitting"

export const EXPORT_EXTRACT_PHYTO_REQUEST =
  "All plant requests have been downloaded successfully."
export const EXPORT_EXTRACT_WINE_REQUEST =
  "All wine and other requests have been downloaded successfully."
export const EXPORT_EXTRACT_OTHER_REQUEST =
  "All requests have been downloaded successfully."

export const OUTDATED_TEMPLATE_MESSAGE =
  "The template on which this certificate is based is no longer current. Please select a new template to start an export request."

export const MAX_PRODUCTS_EXCEEDED = `The number of Products per Certificate cannot be greater than ${maxConfigurableRequestProductCount}`

export const MAX_SOURCE_PRODUCTS_EXCEEDED =
  "The maximum number of source product items that can be referenced on a certificate is 500, this certificate currently sources more than allowed."

export const MAX_SUPPORTING_DOCS_EXCEEDED =
  "Number of Supporting Documents cannot be greater than 50"

export const MAX_SUPPORTING_DOCS_PER_PRODUCT_EXCEEDED =
  "Number of Supporting Documents cannot be greater than 50 per product item"

export const MAX_PROCESSES_PER_CERTIFICATE_EXCEEDED =
  "The number of Processes per Certificate cannot be greater than 800"

export const MIN_PRODUCTS_REQUIRED = "Please enter at least one product"
